import { FieldBlueprint, SelectOptionFieldBlueprint, FieldTypes } from '@zinnia/form-engine-sdk';
import { useState } from 'react';

import { useCastBlueprintToFieldType, FieldDataHookReturnValue } from '../../Helpers/helperTypes';

export type DropdownFieldSetters = {
  setSearchable: (searchable: SelectOptionFieldBlueprint['searchable']) => void;
};

export type DropdownFieldData = {
  searchable: SelectOptionFieldBlueprint['searchable'];
  selectOptions: SelectOptionFieldBlueprint['selectOptions'];
};
export const useDropdownFieldData = ({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<DropdownFieldData, DropdownFieldSetters> => {
  const initialDataAsTypedField = useCastBlueprintToFieldType<SelectOptionFieldBlueprint>(
    FieldTypes.dropdown,
    initialData,
  );

  const [searchable, setSearchable] = useState<SelectOptionFieldBlueprint['searchable']>(
    initialDataAsTypedField?.searchable,
  );

  return {
    data: {
      searchable,
      selectOptions: initialDataAsTypedField?.selectOptions || [],
    },
    setters: { setSearchable },
    clearData: () => {},
  };
};
